export const COMPANY_INFO = {
  name: 'Ad Astra',
  address: '8701 Georgia Avenue, Suite # 808, Silver Spring, MD 20910 US',
} as const
